import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
export function ToolbarLayout({ toolbar, children }) {
    return (_jsxs("div", { className: "relative isolate flex h-full w-full flex-col", children: [_jsx("div", { className: "flex-1", children: children }), _jsx("div", { className: clsx([
                    // Border
                    'border-t border-zinc-950/10 dark:border-white/10',
                    // Backdrop
                    'backdrop-blur-sm dark:backdrop-blur'
                ]), children: toolbar })] }));
}
